var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 73,
    viewBox: "0 0 90 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2806 2.78879L32.6803 2H31.6891H9H4.96457L7.40848 5.21123L33.3358 39.279L9.1964 67.7054L6.39867 71H10.7209H22.355H23.2805L23.8795 70.2946L41.3145 49.7634L56.7194 70.0052L57.3197 70.794H58.3109H81H85.0354L82.5915 67.5827L55.9309 32.5512L78.726 5.7075L81.5237 2.41293H77.2015H65.5674H64.6419L64.0429 3.11835L47.952 22.0669L33.2806 2.78879ZM62.4038 60.603L25.5594 12.1905H27.5962L64.4406 60.603H62.4038Z",
    stroke: "black",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlogo);
export default __webpack_public_path__ + "static/media/Xlogo.f850ad127cb3e00aa1dfb01eeabcd582.svg";
export { ForwardRef as ReactComponent };